var React = require('react');

function Stroke1Blue (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#2E56B4","strokeWidth":"13","d":"M1549 228s-375 21-507-71C954 96 784 6 666 7 427 8 312 151-14 138"}));
}

Stroke1Blue.defaultProps = {"viewBox":"0 0 1440 237"};

module.exports = Stroke1Blue;

Stroke1Blue.default = Stroke1Blue;
